module.exports = __webpack_public_path__ + "static/media/overlay2.7598e994.png";